export default function() {
  return true;
}